//------------------------------------------------------------------------------

// The surface bounds (x_start, y_start, x_end, y_end) of this surface in
// component coordinates (meters, degrees, tubes, etc.)
uniform vec4 u_chunk_rect;

//------------------------------------------------------------------------------

// Interpolated coordinates from the bottom left (xy) of the surface and
// interpolated coordinates from the top right (zw) of the surface
varying vec4 v_component_coords;

//------------------------------------------------------------------------------

void main() {
    // Project this vertex into 3D space, then into the view
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    vec3 modelNormal = normalize(normalMatrix * normal);

    gl_Position = projectionMatrix * viewMatrix * modelPosition;

    v_component_coords = vec4(
    mix(u_chunk_rect.xy, u_chunk_rect.zw, uv),
    mix(u_chunk_rect.zw, u_chunk_rect.xy, uv));
}
